import React, { createContext, useState } from "react";

interface UploadInvoiceActionContextType {
  element: any;
  setElement: (element: any) => void;
  elementId: any;
  setElementId: (elementId: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
}

export const UploadInvoiceActionContext = createContext<UploadInvoiceActionContextType>({
  elementId: null,
  setElementId: () => {},
  element: null,
  setElement: () => {},
  showModal: false,
  setShowModal: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
});

interface UploadInvoiceActionProviderProps {
  children: React.ReactNode;
}

export const UploadInvoiceActionProvider: React.FC<UploadInvoiceActionProviderProps> = ({
  children,
}) => {
  const [elementId, setElementId] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<any>(null);

  const value = {
    elementId,
    setElementId,
    showModal,
    setShowModal,    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
  };
  return (
    <UploadInvoiceActionContext.Provider value={value}>
      {children}
    </UploadInvoiceActionContext.Provider>
  );
};
